import React, { useState, useEffect , useContext } from "react";
import axios from "axios";
import {
    TextField,
    Paper,
    Box,
    AppBar,
    Toolbar,
    Typography,
    Button,
    Alert,
    Grid,
    Select,
    InputLabel,
    FormControl,
    MenuItem,
    Dialog,
    Container,
    Card,
    CardContent,
    Stack
} from "@mui/material"
import WarningTwoToneIcon from '@mui/icons-material/WarningTwoTone';
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  AccountBalance as AccountBalanceIcon,
  Home as HomeIcon,
  Receipt as ReceiptIcon,
} from "@mui/icons-material";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Header from "../Header";
import {
    GridPagination,
    DataGrid,
    getGridStringOperators
  } from '@mui/x-data-grid';
import { NumericFormat,PatternFormat } from "react-number-format";
import { dateDifference, formatDate, formatDateText } from "../CommonFunctions";
import { parseISO,eachDayOfInterval, format } from "date-fns";
import { Link } from "react-router-dom";
import { makeStyles } from '@mui/styles';
import MakePayment from "../MakePayment";

// Define your styles
const useStyles = makeStyles((theme) => ({
  duplicateRow: {
        backgroundColor: '#ffcccc',
        '&:hover': {
            backgroundColor: '#c99393 !important' ,  // Change to desired hover color
        },
  
    },
    noEntryRow: {
      backgroundColor: '#b6e6fa',
      '&:hover': {
          backgroundColor: '#8ed6f5 !important' ,  // Change to desired hover color
      },
    },

      WrongNumberRow: {
        backgroundColor: '#f5ecab',
        '&:hover': {
            backgroundColor: '#eddd66 !important' ,  // Change to desired hover color
        },

  },
  refundedRow: {
    backgroundColor: '#b3db97',
    '&:hover': {
        backgroundColor: '#9adb6b !important' ,  // Change to desired hover color
    },

},
}));

const dotStyles= (colorCode) =>{
  return {
  height: '12px',
  width: '12px',
  borderRadius: '50%',
  display: 'inline-block',
  backgroundColor:`${colorCode}`
  }
}

let last12Months=[];
const options = { month: 'short', day: 'numeric', year:'numeric' };
let totalExpectedRent=0;
let totalAmountReceived=0;
const now=new Date();
now.setDate(1);
const RoomPaymentReport=()=>{
  const currentDate=formatDate(new Date());

  const [searchStartDate,setSearchStartDate]=  useState(formatDate(now));
  const [searchEndDate,setSearchEndDate]=useState(formatDate(new Date()));
  const [reportSummary,setReportSummary] = useState([])
  const [occupancyReport,setOccupancyReport] = useState([]);
  const [last12Months,setLast12Months] = useState([]);
  const [missingPaymentsReportSummary,setMissingPaymentsReportSummary] = useState([]);
  const [makePaymentModal,setMakePaymentModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [sortModel, setSortModel] = useState([]);
  const [missingReceiptWarning, setMissingReceiptWarning] = useState(false);
  let totalExemptAmount=0,totalTaxableAmount=0,totalSalesTax=0,totalTourismTax=0;
  let salesTax=0.07;
  let tourismTax=0.05;
  const roomsToTotalsDict={};
 
    const url=process.env.REACT_APP_SERVER_URL;
    useEffect(() => {
      console.log(parseISO(searchStartDate).toLocaleDateString('en-us',options))
      getPaymentDetailsByDateRange(searchStartDate,searchEndDate);
      getMissingPaymentDetailsByDateRange(searchStartDate,searchEndDate);
        
    }, [searchStartDate,searchEndDate]);
    useEffect(() => {
      getLast12Months();
    }, [currentDate]);
    
    function getLast12Months() {
      const months = [];
      const currentDate = new Date();
      currentDate.setDate(1); // Set to the first day of the current month
  
      for (let i = 0; i < 12; i++) {
          const startDate = new Date(currentDate);
          let endDate = new Date(currentDate);
          if(i!==0){
          endDate.setMonth(endDate.getMonth() + 1);
          endDate.setDate(0); // Set to the last day of the previous month
          }
          else{
            endDate=new Date();
          }
          
  
          months.push({
              startDate: new Date(startDate),
              endDate: new Date(endDate),
          });
  
          // Move to the previous month
          currentDate.setMonth(currentDate.getMonth() - 1);
      }
      console.log(months)
      setLast12Months(months)
  }
  const columns=[
    { field: 'roomid', headerName: 'Room Number', width: 140, align: 'left',
      renderCell:(params)=>{
        const currentRow=params.row;
        return <Link to={
          `/payments/search?searchStartDate=${searchStartDate}&searchEndDate=${searchEndDate}&roomNumber=${currentRow.roomid}`
          } target="_blank">
            {currentRow.roomid}
       
        </Link>
        
       }
      // filterOperators: getGridStringOperators().filter(
      //   (operator) => operator.value === 'equals' 
      // )
    },
    { field: 'numberOfTenancies', headerName: 'Tenancies', width: 140, align: 'left',
      renderCell:(params)=>{
        const currentRow=params.row;
        return <>
        <NumericFormat value={currentRow.numberOfTenancies} thousandSeparator prefix={''} displayType="text"/>
        </>
        
       }
    },
    { field: 'totalRent', headerName: 'Total Expected Rent', width: 180, align: 'left',
        renderCell:(params)=>{
          const currentRow=params.row;
          return <>
          <NumericFormat value={currentRow.totalRent} thousandSeparator prefix={'$'} displayType="text" style={{color:"grey"}}/>
          </>
          
         }
       },
  
      { field: 'totalAmount', headerName: 'Amount Paid', width: 180, align: 'left',
        renderCell:(params)=>{
          const currentRow=params.row;
          return <b>
          <NumericFormat value={currentRow.totalAmount} thousandSeparator prefix={'$'} displayType="text"/>
          </b>
          
         }
       },
       { field: 'difference', headerName: 'Difference', width: 180, align: 'left',
        renderCell:(params)=>{
          const currentRow=params.row;
          // const difference=currentRow.totalAmount-currentRow.totalRent
          return <>
          <NumericFormat value={currentRow.difference} 
          thousandSeparator prefix={'$'} displayType="text"
          style={{color: currentRow.difference<0 ? "red" : "black"}}
          />
         
          </>
          
         }
       },
   
     

  ]
  const getPaymentDetailsByDateRange = async(searchStartDate,searchEndDate) =>{
    const dateColumnFilter = 'actualPaymentDate';
    await axios.post(`${url}/payments/allPaymentsinDateRange`,{
        searchStartDate,
        searchEndDate,
        dateColumnFilter
      }).then(async(responseForTenancyDetails)=>{
        console.log(responseForTenancyDetails.data)
        if(responseForTenancyDetails && responseForTenancyDetails.data)
        setReportSummary(responseForTenancyDetails.data)
       
      })
  }
  const getMissingPaymentDetailsByDateRange = async(searchStartDate,searchEndDate) =>{
    const dateColumnFilter = 'actualPaymentDate';
    await axios.post(`${url}/getMissingPayments`,{
        searchStartDate,
        searchEndDate,
        dateColumnFilter
      }).then(async(responseForTenancyDetails)=>{
        console.log(responseForTenancyDetails.data)
        if(responseForTenancyDetails && responseForTenancyDetails.data)
        setMissingPaymentsReportSummary(responseForTenancyDetails.data)
       
      })
    }
  
    const preProcess = (data,missingData)=>{
      let idToDetails={};
      let roomToTotals={};
      for(let itr in data){
        let currentRow=data[itr];
        let amount=0;
            if(currentRow.cashAmount)
                amount=amount+parseInt(currentRow.cashAmount);
            if(currentRow.creditCardAmount)
                amount+=parseInt(currentRow.creditCardAmount);
            if(currentRow.otherAmount)
                amount+=parseInt(currentRow.otherAmount);
        if(currentRow.id in idToDetails){
          let curr=roomToTotals[currentRow.roomid]
          roomToTotals[currentRow.roomid]={
            id:currentRow.id,
            roomid:currentRow.roomid,
            numberOfTenancies: curr.numberOfTenancies,
            totalRent: curr.totalRent,
            totalAmount: curr.totalAmount + amount,
            difference: curr.totalAmount + amount - curr.totalRent
          }

        }
        else{
          idToDetails[currentRow.id] = currentRow;
          let roomid=currentRow.roomid;
          
          if(roomid in roomToTotals){
            let curr=roomToTotals[roomid];
            let difference=curr.totalAmount + amount;
            difference-=(curr.totalRent + currentRow.rate)
            roomToTotals[currentRow.roomid]={
              id:currentRow.id,
              roomid:currentRow.roomid,
              numberOfTenancies: curr.numberOfTenancies +1,
              totalRent: curr.totalRent + currentRow.rate,
              totalAmount: curr.totalAmount + amount,
              difference: difference
            }

          }
          else{
            roomToTotals[currentRow.roomid]={
              id:currentRow.id,
              roomid:currentRow.roomid,
              numberOfTenancies:1,
              totalRent:currentRow.rate,
              totalAmount: amount,
              difference: amount - currentRow.rate

            }

          }

          
        }
      }
      for(let itr in missingData){
        let currentRow=missingData[itr];
        if(currentRow.roomid in roomToTotals){
          const curr=roomToTotals[currentRow.roomid];
          roomToTotals[currentRow.roomid]={
            id:currentRow.id,
            roomid:currentRow.roomid,
            numberOfTenancies:curr.numberOfTenancies +1,
            totalRent:curr.totalRent+currentRow.rate,
            totalAmount: curr.totalAmount,
            difference: curr.totalAmount - (curr.totalRent + currentRow.rate)

          }

        }
        else{
          roomToTotals[currentRow.roomid]={
            id:currentRow.id,
            roomid:currentRow.roomid,
            numberOfTenancies:1,
            totalRent:currentRow.rate,
            totalAmount: 0,
            difference: -currentRow.rate

          }
        }
      }
      let resultArray=[];
      totalExpectedRent=0;
      totalAmountReceived=0;
      for (const key in roomToTotals) {
        resultArray.push(roomToTotals[key]);
        totalExpectedRent+=parseInt(roomToTotals[key].totalRent);
        totalAmountReceived+=parseInt(roomToTotals[key].totalAmount);
      }
      console.log(resultArray);
      return resultArray;
     }
  // Function to check for the first missing receipt number
  const findFirstMissingReceiptNumber = (sortedRows) => {
    for (let i = 1; i < sortedRows.length; i++) {
      const prevReceipt = sortedRows[i - 1].receiptNumber;
      const currentReceipt = sortedRows[i].receiptNumber;

      if (currentReceipt - prevReceipt > 1) {
        return parseInt(prevReceipt) + 1; // Return the first missing receipt number
      }
    }
    return null;
  };

  // Handle sort model change
  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);

    // Check if the receiptNumber column is sorted
    const isReceiptNumberSorted = newSortModel.some(
      (model) => model.field === 'receiptNumber'
    );
    const isAscending = newSortModel.some(
      (model) =>  model.sort === 'asc'
    );

    if (isReceiptNumberSorted) {
      // Sort the rows by receipt number
      if(isAscending){
      const sortedRows = [...reportSummary].sort((a, b) => a.receiptNumber - b.receiptNumber);
      const missingReceipt = findFirstMissingReceiptNumber(sortedRows);

      if (missingReceipt) {
        // Add a row indicating a missing receipt number if there's a gap
        setReportSummary((prevRows) => [
          ...prevRows,
          {
            id: prevRows.length + 1,
            name: 'Missing Receipt Number',
            receiptNumber: `${missingReceipt} (Warning)`, //Hide the receipt number while
          },
        ]);
      }
    }
    } else {
      // Remove the "missing" row if sorting a different column
      setReportSummary((prevRows) =>
        prevRows.filter((row) => !row.receiptNumber.toString().includes('Warning'))
      );
    }
  };
  const MissingReceiptNumberWarning=()=>{
    return <>
    <React.Fragment>
      <Button variant="outlined" onClick={(e)=>{
        setMissingReceiptWarning(false)
      }}>
        
      </Button>
      <Dialog
        open={missingReceiptWarning}
        onClose={(e)=>{
          setMissingReceiptWarning(false)
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            The Missing Receipt Number
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </React.Fragment>
    </>
}
  function CustomPagination(props) {
    return <>
    <b>Total Expected Rent
    <NumericFormat value={totalExpectedRent} thousandSeparator prefix={'$'} displayType="text"/></b>
        <b>Total Amount Received
        <NumericFormat value={totalAmountReceived} thousandSeparator prefix={'$'} displayType="text"/></b>
        <b>Number of rooms
        <NumericFormat value={0} thousandSeparator prefix={'$'} displayType="text"/></b>
        
        <GridPagination  {...props} /> </>;
  }
  
  const processedData = preProcess(reportSummary, missingPaymentsReportSummary);
  const collectionRate =
    totalExpectedRent > 0
      ? ((totalAmountReceived / totalExpectedRent) * 100).toFixed(1)
      : 0;
    
  const classes = useStyles();

    return (
      <>
      <Header/>
        
      <Box sx={{ bgcolor: "#f5f7fa", minHeight: "100vh", py: 3 }}>
        <Container maxWidth="xl">
          
          {/* Header with Date Selection in Single Line */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              mb: 3,
              pb: 2,
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Room Payment Report
            </Typography>

            <Box sx={{ flexGrow: 1 }} />

            <TextField 
              id="start-date" 
              label="Start Date" 
              variant="outlined" 
              size="small"
              type="date" 
              value={searchStartDate} 
              onChange={(e)=>{
                setSearchStartDate(e.target.value);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                minWidth: 180,
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: 'primary.main',
                  },
                },
              }}
            />
            
            <TextField 
              id="end-date" 
              label="End Date" 
              variant="outlined" 
              size="small"
              type="date" 
              value={searchEndDate} 
              onChange={(e)=>{
                setSearchEndDate(e.target.value);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                minWidth: 180,
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: 'primary.main',
                  },
                },
              }}
            />
            
            <Button 
              variant="contained" 
              onClick={(e)=>{
                getPaymentDetailsByDateRange(searchStartDate,searchEndDate);
                getMissingPaymentDetailsByDateRange(searchStartDate,searchEndDate);
              }}
              sx={{
                textTransform: 'none',
                fontWeight: 600,
              }}
            >
              Search
            </Button>
          </Box>

          {/* Summary Cards */}
          <Grid container spacing={3} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        bgcolor: "primary.main",
                        color: "white",
                        p: 1.5,
                        borderRadius: 2,
                        display: "flex",
                      }}
                    >
                      <HomeIcon />
                    </Box>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Total Rooms
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {processedData.length}
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        bgcolor: "warning.main",
                        color: "white",
                        p: 1.5,
                        borderRadius: 2,
                        display: "flex",
                      }}
                    >
                      <ReceiptIcon />
                    </Box>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Expected Rent
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        <NumericFormat 
                          value={totalExpectedRent} 
                          thousandSeparator 
                          prefix={'$'} 
                          displayType="text"
                        />
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        bgcolor: "success.main",
                        color: "white",
                        p: 1.5,
                        borderRadius: 2,
                        display: "flex",
                      }}
                    >
                      <AccountBalanceIcon />
                    </Box>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Amount Received
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        <NumericFormat 
                          value={totalAmountReceived} 
                          thousandSeparator 
                          prefix={'$'} 
                          displayType="text"
                        />
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Card elevation={2}>
                <CardContent>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Box
                      sx={{
                        bgcolor:
                          totalAmountReceived - totalExpectedRent < 0
                            ? "error.main"
                            : "success.main",
                        color: "white",
                        p: 1.5,
                        borderRadius: 2,
                        display: "flex",
                      }}
                    >
                      {totalAmountReceived - totalExpectedRent < 0 ? (
                        <TrendingDownIcon />
                      ) : (
                        <TrendingUpIcon />
                      )}
                    </Box>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Collection Rate
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {collectionRate}%
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          {/* Data Grid */}
          <Paper elevation={2} sx={{ borderRadius: 2 }}>
            <Box
              sx={{
                height: 550,
                width: '100%',
                '& .actions': {
                  color: 'text.secondary',
                },
                '& .textPrimary': {
                  color: 'text.primary',
                },
              }}
            >
              <DataGrid 
                rows={processedData} 
                columns={columns}
                getRowId={(row) => row.paymentId + ' ' + row.id}
                slots={{
                  pagination: CustomPagination,
                }}
                getRowClassName={(params) =>
                  params.row.receiptNumberStatus=="duplicate" ? classes.duplicateRow : 
                  params.row.receiptNumberStatus=="no-entry" ? classes.noEntryRow : 
                  params.row.receiptNumberStatus=="wrong-number" ? classes.WrongNumberRow : 
                  params.row.receiptNumberStatus=="refunded" ? classes.refundedRow : classes.normalRow
                }
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
                sx={{
                  border: "none",
                  "& .MuiDataGrid-cell": {
                    borderBottom: 1,
                    borderColor: "divider",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    bgcolor: "grey.50",
                    borderBottom: 2,
                    borderColor: "divider",
                  },
                }}
              />
            </Box>
          </Paper>
          
        </Container>
      </Box>
      
      {makePaymentModal && <MakePayment value={{paymentDetails:selectedRow}}/>}
      {missingReceiptWarning && <MissingReceiptNumberWarning/>}
      </>
    );


}
export default RoomPaymentReport;